import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿El pago es único?',
  a: 'Sí, es un pago único. No hay suscripciones ni cobros mensuales ocultos. Pagás una vez y tenés acceso al material para descargarlo y usarlo para siempre.'
}, {
  q: '¿Cómo recibo el material?',
  a: '¡Atención a esto! Al momento de la compra vas a ingresar un correo electrónico. Una vez aprobado el pago, el contenido te llega automáticamente a ese mail. Por favor, revisá tu bandeja de SPAM o Promociones. Si tenés cualquier inconveniente, podés comunicarte a sectordigital53@gmail.com y te ayudamos enseguida.'
}, {
  q: '¿Sirve si recién empiezo a trabajar con deportistas con discapacidad?',
  a: 'Totalmente. Justamente el KIT está diseñado para darte una estructura paso a paso (las 8 etapas) para que no tengas que improvisar. Te guía desde qué preguntar en la primera sesión hasta cómo cerrar el proceso.'
}, {
  q: '¿Reemplaza una formación o supervisión profesional?',
  a: 'No. Este KIT es un conjunto de herramientas clínicas y prácticas para organizar tu trabajo, pero no reemplaza una formación de posgrado, especialización ni la supervisión de casos clínicos.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí, tenés 7 días de garantía. Si comprás el KIT, lo revisás y sentís que no te aporta valor o no es lo que esperabas, nos escribís y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿Los bonos están incluidos en el precio?',
  a: 'Sí, si comprás hoy, los dos bonos (Guía de psicoeducación y Banco de técnicas) están incluidos de forma 100% gratuita con tu compra del KIT.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 bg-[#0c3b42] text-white" data-id="element-69">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-70">
        <div className="text-center mb-12" data-id="element-71">
          <h2 className="text-3xl font-black text-[#7fd1c9] uppercase tracking-tight" data-id="element-72">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-73">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white/10 border border-white/20 rounded-xl overflow-hidden" data-id="element-74">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-75">
                <span className="font-bold text-lg pr-4" data-id="element-76">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-77" />
              </button>

              <AnimatePresence data-id="element-78">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-79">
                    <div className="px-6 pb-5 text-slate-300 leading-relaxed border-t border-white/10 pt-4" data-id="element-80">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}